module.exports = __webpack_public_path__ + "static/media/FWI_AI_1.e1ae3d79.jpg";